import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ReactComponent as DropdownSVG } from "go-core/images/svg/actions/collapse.svg";
import {
	SubscriptionVisibility,
	SubscriptionsApi,
	UpdateSubscriptionsApi,
} from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import SubscriptionTotalPrice from "../Preview/SubscriptionTotalPrice";
import StickySubscriptionsSummaryDetails from "./StickySubscriptionsSummaryDetails";

interface Props {
	estimate: SubscriptionsApi;
	setShowSummaryPreview: (value: boolean) => void;
	errors: any;
	subscriptionsVisibility: SubscriptionVisibility;
	estimating: boolean;
	form: UseFormReturn<UpdateSubscriptionsApi>;
	update: () => void;
	showSummaryPreview: boolean;
}

const StickySubscriptionsSummary = ({
	subscriptionsVisibility,
	update,
	form,
	setShowSummaryPreview,
	estimating,
	estimate,
	errors,
	showSummaryPreview,
}: Props) => {
	const { t } = useTranslation();
	const [expanded, setExpanded] = useState(false);
	const disableButton =
		(errors && Object.keys(errors).length > 0) ||
		subscriptionsVisibility === SubscriptionVisibility.READ_ONLY ||
		estimating ||
		(Array.isArray(estimate.warnings) && estimate.warnings.length > 0);

	if (showSummaryPreview) return <></>;

	const handleSave = () => {
		if (subscriptionsVisibility === SubscriptionVisibility.VISIBLE) {
			setShowSummaryPreview(true);
			document.querySelector(".content")?.scrollTo(0, 0);
		}
	};

	return (
		<div className="sticky-subscriptions-summary">
			{expanded && (
				<StickySubscriptionsSummaryDetails
					estimate={estimate}
					form={form}
					addCoupon={update}
					setExpanded={setExpanded}
				/>
			)}
			<div
				className="d-flex justify-content-between sticky-subscriptions-summary-bottom"
				onClick={() => setExpanded(true)}
			>
				<h6>{t("lib:common.word.summary")}</h6>
				<div className="d-flex gap-2">
					<div className="d-flex flex-column">
						<SubscriptionTotalPrice totals={estimate.totals} />
					</div>
					{!expanded && <DropdownSVG className="icon dropdown-icon--expanded" />}
				</div>
			</div>
			<Button
				disabled={disableButton}
				onClick={handleSave}
				className="mt-2 subscriptions-payment-summary-submit-button"
			>
				{t("modules.subscription.action.next.title")}
			</Button>
			{subscriptionsVisibility === SubscriptionVisibility.READ_ONLY && (
				<small className="text-danger mt-1"> {t("constraints.not_supported")}</small>
			)}
		</div>
	);
};

export default StickySubscriptionsSummary;
